<template>
    <CContainer fluid>
      <h3>Control Documentos Electr&oacute;nicos de Venta</h3>
      <CCard>
        <CCardBody>
          <CRow>
            <CCol col="6" sm="3" md="3">
              <label class="text-muted font-weight-bold">Fecha Inicial:</label>
              <DatePicker 
                type="date" 
                v-model="fechaInicial"
                value-type="YYYY-MM-DD"
                format="DD/MM/YYYY"
                placeholder="dd/mm/aaaa" />
            </CCol>
            <CCol col="6" sm="3" md="3">
              <label class="text-muted font-weight-bold">Fecha Final:</label>
              <DatePicker 
                type="date"
                v-model="fechaFinal"
                value-type="YYYY-MM-DD"
                format="DD/MM/YYYY"
                placeholder="dd/mm/aaaa" />
            </CCol>
            <CCol col="6" sm="3" md="3">
              <CSelect 
                class=""
                label="Tipo Documento:"
                addLabelClasses="text-muted font-weight-bold"
                :options="listTiposDocumento"
                :value.sync="tipoDocumentoSelected" />
            </CCol>
            <CCol col="1" sm="1">
              <CButton 
                color="info" 
                variant="outline" 
                class="mt-4" 
                @click="getData(1)" >
                <CIcon name="cil-search" />
              </CButton>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <CCard class="mt-4">
        <CCardBody>
          <!-- <CRow>
            <CCol col="sm-6">
              <CInput 
                label="Buscar: "
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="searchWord" 
                @keyup.enter="getData(1, searchWord)">
                <template #prepend-content>
                  <a href="#" @click="getData(1)">
                    <i class="bi bi-arrow-clockwise"></i>
                  </a>
                </template>
                <template #append-content>
                  <a href="#" @click="getData(1, searchWord)">
                    <i class="bi bi-search"></i>
                  </a>
                </template>
              </CInput>
            </CCol>
          </CRow> -->
          <CDataTable
            hover
            responsive
            :items="documents"
            :fields="fields"
            :items-per-page="5"
            @row-clicked="(item, index, _columnName, e) => {
              e.preventDefault()
              goTo(item, 'detalle')
            }">
            <template #documento="{item}">
              <td>
                <div>
                  <h4>{{ item.Prefijo }} {{ item.Numero }}</h4>
                  <small>{{ item.Descripcion }}</small>
                </div>
              </td>
            </template>
            <template #empresa="{item}">
              <td>
                <div>
                  <span>
                    <CIcon name="cil-building" class="mr-1"/>
                    <strong>{{ item.Empresa }}</strong>
                  </span>
                </div>
                <div>
                  <span>
                    <i class="bi bi-postcard mr-1"></i>
                    {{ item.Identificacion }}
                  </span>
                </div>
                <div>
                  <span>
                    <i class="bi bi-person-workspace mr-1"></i>
                    {{item.Nombre_Empleado}}
                  </span>
                </div>
              </td>
            </template>
            <template #fechas="{item}">
              <td>
                <div>
                  <CIcon name="cil-calendar" class="mr-1"/>
                  <span>
                    {{ moment(item.Fecha_Emision).format('DD/MM/YYYY') }}
                  </span>
                </div>
                <div v-if="item.Tipo_Movimiento == 'E'">
                  <i class="bi bi-cloud-check text-success h4 mr-1"></i>
                  <small>Transmitido</small>
                </div>
                <div v-else>
                  <i class="bi bi-cloud-slash text-danger h4 mr-1"></i>
                  <small>Sin Transmitir</small>
                </div>
                <div v-if="item.Tipo_Impresion == 'CE'">
                  <i class="bi bi-envelope-check text-success h5 mr-1"></i>
                  <small>Enviado</small>
                </div>
                <div v-else>
                  <i class="bi bi-envelope-x text-danger h5 mr-1"></i>
                  <small>Sin Enviar</small>
                </div>
                <div v-if="item.Estado_Evento">
                  <i class="bi bi-info-circle text-info h5 mr-1"></i>
                  <small>{{ item.Estado_Evento }}</small>
                </div>
              </td>
            </template>
            <template #valores="{item}">
              <td>
                <div class="d-flex justify-content-end">
                    <span>${{ formatter.format(item.Valor_Mercancia, 2) }}</span>
                </div>
                <div class="d-flex justify-content-end">
                    ${{formatter.format(item.Valor_Iva, 2)}}
                </div>
                <div class="d-flex justify-content-end">
                    <strong>${{ formatter.format(item.Valor_Total, 2) }}</strong>
                </div>
              </td>
            </template>
            <template #detalles="{item}">
              <td>
                <a href="#"
                  class="mb-2 p-2"
                  style="text-decoration: none;"
                  @click="toggleDocument($event, item)">
                  <CIcon 
                    class="text-dark" 
                    :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'">
                  </CIcon>
                </a>
              </td>
            </template>
            <template #details="{item}">
              <CCollapse class="my-3" :show="item._toggled">
                <div class="d-flex justify-content-end mb-3">

                  <a href="#" 
                    class="mr-3" 
                    v-c-tooltip="'Detalle de Productos de la factura'"
                    @click="openPanelKardex($event, item.Id_Documento)">
                    <i class="bi bi-journal-text text-info h4"></i>
                  </a>
  
                  <!-- ToDo -->
                  <a href="#" 
                    class="mr-3" 
                    v-c-tooltip="'Cargar Documento Anexo'"
                    @click="openPanelUploadAttachment($event, item.Id_Documento)">
                    <Icon icon="fluent:document-arrow-up-20-regular" class="text-s3fuchsia h3" />
                  </a>
                  <a href="#" 
                    class="mr-3" 
                    v-c-tooltip="'Documentos Anexos'" 
                    @click="openPanelAttachments($event, item.Id_Documento)">
                    <Icon icon="teenyicons:attachment-outline" class="text-s3brown h4" />
                  </a>
  
                  <!-- ToDo -->
                  <a href="#" v-if="item.Tipo_Movimiento !== 'E'"
                    class="mr-3" 
                    v-c-tooltip="'Enviar Documento Electronico'" 
                    @click="sendElectronicDocument($event, item.Id_Documento)">
                    <Icon icon="mdi:receipt-text-send-outline" class="text-s3tail h3" />
                  </a>

                  <a href="#" 
                    class="mr-3"
                    v-c-tooltip="'Enviar correo Documento Electronico'"
                    @click="sendMailDocument($event, item.Id_Documento)">
                    <Icon icon="material-symbols:mark-email-read-outline" class="h3" />
                  </a>
                  
                  <a href="#" 
                    class="mr-3" 
                    v-c-tooltip="'Documentos DIAN'" 
                    @click="openPanelDownloadDocumentsDIAN($event, item.Id_Documento, item.CUDE)">
                    <Icon icon="lucide:folder-down" class="text-s3violet h3" />
                  </a>
                </div>
                <CCol col="12" sm="12">
                  <div class="ml-4"><strong>Comentarios: </strong></div>
                  <div class="ml-4">{{item.Comentario_01}}</div>
                  <div class="ml-4">{{item.Comentario_02}}</div>
                  <div class="ml-4"><strong>CUDE:</strong></div>
                  <div class="ml-4"><small>{{ item.CUDE }}</small></div>
                </CCol>
              </CCollapse>
            </template>
          </CDataTable>
          <CPagination 
            size="sm" 
            class="d-flex justify-content-center" 
            :activePage.sync="page" 
            :pages="pageCount" 
            @update:activePage="(value) => getData(value)" 
          />
        </CCardBody>

        <CElementCover v-show="loading" />
        <LoadingCover message="Procesando..." spinner="circles" v-show="showProcess" />
      </CCard>
  
      <RightSideBar size="lg" :show="showPanelKardex" class="bg-s3grey">
        <CContainer>
          <CCard class="mt-4">
            <CCardHeader>
              <CCardTitle>
                Productos Facturados
              </CCardTitle>
              <CCardSubtitle>
                <small>
                  Detalle de los productos facturados
                </small>
              </CCardSubtitle>
            </CCardHeader>
            <CCardBody>
              <div class="panel-scroll">
                <DocumentKardex :idDocument="idDocumento" :key="updateComponent" />
              </div>
            </CCardBody>
            <CCardFooter>
              <div class="d-flex justify-content-center">
                <CButton 
                  color="primary"
                  @click="showPanelKardex=false">
                  <span class="align-middle">Cerrar</span>
                </CButton>
              </div>
            </CCardFooter>
          </CCard>
        </CContainer>
      </RightSideBar>
  
      <RightSideBar :show="showPanelDownloadDocumentsDIAN" class="bg-s3grey">
        <CContainer>
          <CCard class="mt-3">
            <CCardHeader>
              <CCardTitle>
                Descarga de documentos DIAN
              </CCardTitle>
              <CCardSubtitle>
                <small>
                  Descargue los diferentes tipos de documentos relacionados con la factura de venta electronica ante la DIAN y/o valide la factura electr&oacute;nica en el portal de la DIAN.
                </small>
              </CCardSubtitle>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol col="sm-12">
                  <CCallout color="danger">
                    <div class="d-flex justify-content-middle puntero" 
                      @click="downloadElectronicDocument($event, idDocument, 'PDF')">
                      <i class="bi bi-file-earmark-pdf text-danger h1 mr-2"></i>
                      <small>Representaci&oacute;n gr&aacute;fica de la factura electr&oacute;nica en PDF</small>
                    </div>
                  </CCallout>
                </CCol>
                <CCol col="sm-12">
                  <CCallout color="success">
                    <div class="d-flex justify-content-middle puntero" 
                      @click="downloadElectronicDocument($event, idDocument, 'XML')">
                      <i class="bi bi-filetype-xml text-success h1 mr-2"></i>
                      <small>Archivo XML de la factura electronica DIAN.</small>
                    </div>
                  </CCallout>
                </CCol>
                <CCol col="sm-12">
                  <CCallout
                    color="warning" >
                    <div class="d-flex justify-content-middle puntero" 
                      @click="downloadElectronicDocument($event, idDocument, 'ZIP')">
                      <i class="bi bi-file-earmark-zip text-warning h1 mr-2"></i>
                      <small>Archivo ZIP con el XML y el PDF de la factura electronica DIAN.</small>
                    </div>
                  </CCallout>
                </CCol>
                <CCol col="12" sm="12">
                  <CCallout color="s3green">
                    <div class="d-flex justify-content-middle puntero" 
                      @click="getUrlElectronicDocument($event, hashDocument)">
                      <i class="bi bi-link-45deg text-s3green h1 mr-2"></i>
                      <small>Validar en la p&aacute;gina de la DIAN el registro de la factura electr&oacute;nica de venta.</small>
                    </div>
                  </CCallout>
                </CCol>
              </CRow>
            </CCardBody>
            <CCardFooter>
              <div class="d-flex justify-content-center">
                <CButton 
                  color="primary" 
                  @click="showPanelDownloadDocumentsDIAN=false">
                  <CIcon name="cil-x-circle"></CIcon>
                  <span class="align-middle ml-2">Cerrar</span>            
                </CButton>
              </div>
            </CCardFooter>
          </CCard>
        </CContainer>
      </RightSideBar>
  
      <!-- Panel sidebar para agregar documentos anexos -->
      <RightSideBar size="md" class="bg-s3grey" :show="showPanelUploadAttachment">
        <FormAttachments 
          :idDocument="idDocumento" 
          :key="updateComponentAttachments" 
          @closeWindow="closePanelAttachments">
        </FormAttachments>
      </RightSideBar>

      <!-- Panel sidebar para visualizar los documentos anexos -->
      <RightSideBar size="md" class="bg-s3grey" :show="showPanelAttachments">
        <CContainer>
          <CCard class="mt-3">
            <CCardHeader>
              <CCardTitle>
                Documentos Anexos
              </CCardTitle>
            </CCardHeader>
            <CCardBody>
              <AttachedDocuments v-if="showPanelAttachments" 
                typeQuery="documento" 
                :id="idDocumento">
              </AttachedDocuments>
            </CCardBody>
            <CCardFooter>
              <div class="d-flex justify content-center">
                <CButton 
                  color="primary"
                  class="ml-2"
                  @click="showPanelAttachments=false">
                  <CIcon name="cil-x-circle"></CIcon>
                  <span class="align-middle ml-2">Cancelar</span>
                </CButton>
              </div>
            </CCardFooter>
          </CCard>
        </CContainer>
      </RightSideBar>
  
    </CContainer>
  </template>
  <style>
    .panel-scroll {
      overflow-y: scroll;
      height: 60vh;
      max-height: 100vh;
    }
  </style>
  <script>
    import moment from "moment"
    import { Icon } from "@iconify/vue2"
    import DatePicker from "vue2-datepicker";

    import { formatter } from '../../general'
    import CONSTANTS from "../../constants"
    import { downloadFileObject } from "@/api";
    import { dataGridDocumentosElectronicos } from "@/apiDataGrids"
    import { descargarFacturaElectronica } from "@/apiReports";
    import { 
      sendElectronicDocument, 
      sendMailElectronicDocument 
    } from "@/apiProcess";
  
    import RightSideBar from "../containers/RightSideBar.vue";
    import LoadingCover from "@/components/containers/LoadingCover.vue";
    import DocumentKardex from "../datagrids/DocumentKardex.vue"
    import FormAttachments from "../forms/FormAttachments.vue"
    import AttachedDocuments from "../datagrids/AttachedDocuments.vue"
  
    const fields = [
      {
        key: 'documento', 
        label: 'Documento',
        _style:'text-align:center;'
      },
      {
        key: 'empresa', 
        label: 'Empresa',
        _style:'text-align:center;'
      },
      {
        key: 'fechas', 
        label: 'Fechas',
        _style:'text-align:center;'
      },
      {
        key: 'valores', 
        label: 'Valores',
        _style:'text-align:center;'
      },
      {
        key: 'detalles',
        label: ''
      }
    ]
  
  export default {
    name: 'ElectronicDocuments',
    components: {
      Icon,
      DatePicker,
      RightSideBar,
      LoadingCover,
      DocumentKardex,
      FormAttachments,
      AttachedDocuments
    },
    data() {
      return {
        formatter,
        loading: false,
        processing: false,
        showProcess: false,
        showPanelSeriales: null,
        showPanelKardex: null,
        showPanelAttachments: null,
        showPanelUploadAttachment: null,
        showPanelDownloadDocumentsDIAN: null,
        updateComponent: 0,
        updateComponentAttachments: 0,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: '',
        fields,
        documents: [],
        fechaInicial: "",
        fechaFinal: "",
        listTiposDocumento: [
          { label: "Todos", value: "TO" },
          { label: "Facturas", value: "FV" },
          { label: "Notas Credito", value: "NC" }
        ],
        tipoDocumentoSelected: "",
        idDocumento: "",
        cudeDocument: ""
      }
    },
    methods: {
      moment,
      async getData(page) {
        this.loading = true
        
        try {
          const { pages, result } = await dataGridDocumentosElectronicos(
            this,
            this.fechaInicial,
            this.fechaFinal,
            this.tipoDocumentoSelected,
            page
          );

          this.page = page;
          this.pageCount = pages
          this.documents = result;
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally{
          this.loading = false
        }        
      },
      async sendElectronicDocument(e, idDocument) {
        e.preventDefault();
        e.stopPropagation();

        this.showProcess = true;

        try {
          const { errorCode, errorMessage } = await sendElectronicDocument(this, idDocument, null);

          if (errorCode === 0) {
            this.getData(this.page)

            this.$store.commit("setAlert", {
              color: "success",
              message: "El Documento fue enviado correctamente a la DIAN.",
              show: 5
            });
          } else {
            this.$store.commit("setAlert", {
              color: "danger",
              message: "Error al enviar el documento a la DIAN. Error: " + errorMessage,
              show: 5
            });
          }
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al enviar el documento a la DIAN.",
            show: 5
          });
        } finally {
          this.showProcess = false;
        }
      },
      async sendMailDocument(e, idDocument) {
        e.stopPropagation();
        e.preventDefault();

        this.showProcess = true;
  
        try {
          const { errorCode, errorMessage } = await sendMailElectronicDocument(this, idDocument);
  
          if (errorCode === 0) {
            this.getData(this.page)

            this.$store.commit("setAlert", {
              color: "success",
              message: "El Correo Electronico con el Documento fue enviado correctamente.",
              show: 5
            });
          } else {
            this.$store.commit("setAlert", {
              color: "danger",
              message: errorMessage,
              show: 5
            });
          }
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al enviar el correo electronico.",
            show: 5
          })
        } finally {
          this.showProcess = false;
        }
      },
      async downloadElectronicDocument(e, idDocument, typeDocument) {
        e.stopPropagation();
        e.preventDefault();
  
        this.loading = true
  
        try {
          const { response } = await descargarFacturaElectronica(this, idDocument, typeDocument)
          const { nombreArchivo, contenidoArchivo } = response
  
          downloadFileObject(nombreArchivo, typeDocument, contenidoArchivo)
        } catch(error) {
          this.$store.commit("setAlert", {
              color: "danger",
              message: "Ocurrio un error al descargar el archivo de facturación electrónica.",
              show: 5
            })
        } finally {
          this.loading = false
        }
      },
      getUrlElectronicDocument(e, cude) {
        e.stopPropagation();
        e.preventDefault();
  
        if (cude) {
          const urlDocumentDIAN = `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${cude}`
  
          window.open(urlDocumentDIAN, "_blank")
        } else {
          this.$alert("¡La factura aun no se ha transmitido a la DIAN!", "", "warning", CONSTANTS.configSimpleAlert)
        }
      },
      openPanelKardex(e, idDocument) {
        e.stopPropagation();
        e.preventDefault();
  
        this.showPanelKardex = true
        this.idDocumento = idDocument
        this.updateComponent += 1
      },
      openPanelUploadAttachment(e, idDocument) {
        e.stopPropagation();
        e.preventDefault();
  
        this.idDocumento = idDocument
        this.updateComponentAttachments++
        this.showPanelUploadAttachment = true
      },
      openPanelAttachments(e, idDocument) {
        e.stopPropagation();
        e.preventDefault();
  
        this.showPanelAttachments = true
        this.idDocumento = idDocument
        this.updateComponentAttachments++
      },
      closePanelAttachments() {
        this.showPanelUploadAttachment = false
      },
      openPanelDownloadDocumentsDIAN(e, idDocument, hashDocument) {
        e.stopPropagation();
        e.preventDefault();
  
        this.showPanelDownloadDocumentsDIAN = true;
        this.idDocument = idDocument;
        this.hashDocument = hashDocument;
      },
      toggleDocument(e, item){
        e.stopPropagation();
        e.preventDefault();
  
        this.$set(item, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      }
    },
    created() {
      // this.fechaInicial = moment().startOf("month").format("YYYY-MM-DD");
      this.fechaInicial = moment().format("YYYY-MM-DD");
      this.fechaFinal = moment().format("YYYY-MM-DD");
      this.tipoDocumentoSelected = "TO"
    },
    mounted() {
      console.clear;

      this.getData(this.page)
    }
  }
  </script>